import { el } from "./dom.js";

const VISIBLE_MS = 2400;

export class LevelUpBanner {
  readonly root: HTMLElement;
  private readonly title: HTMLElement;
  private readonly sub: HTMLElement;
  private hideTimer = 0;

  constructor() {
    this.title = el("div", { class: "levelup-title" }, "Level Up!");
    this.sub = el("div", { class: "levelup-sub" }, "");
    this.root = el("div", { class: "levelup-banner hidden" }, this.title, this.sub);
  }

  show(newLevel: number): void {
    this.sub.textContent = `You reached level ${newLevel}`;
    this.root.classList.remove("hidden");
    // Restart animation
    this.root.classList.remove("playing");
    void this.root.offsetWidth;
    this.root.classList.add("playing");
    if (this.hideTimer) window.clearTimeout(this.hideTimer);
    this.hideTimer = window.setTimeout(() => {
      this.root.classList.add("hidden");
      this.hideTimer = 0;
    }, VISIBLE_MS);
  }

  destroy(): void {
    if (this.hideTimer) window.clearTimeout(this.hideTimer);
    this.hideTimer = 0;
    this.root.remove();
  }
}
